module.exports = __webpack_public_path__ + "images/amores.78103054739a2936feb70225d864e5e5.jpg";